/* eslint-disable jsx-a11y/anchor-has-content */
import { HeaderNull } from '../../../component/HeaderNull'
import './LienHeHoTro.scss'

function LienHeHoTro () {
  const data = [
    {
      name: 'Điện thoại',
      icon: '/caidat/phone.png',
      link: 'tel:1900 123456',
      content: '+84779036888'
    },
    {
      name: 'Email',
      icon: '/caidat/mail.png',
      link: 'mailto:QK88BETcom@gmail.com',
      content: 'QK88BETcom@gmail.com'
    },
    {
      name: 'Telegram',
      icon: '/caidat/tele.png',
      link: 'https://t.me/QK88BETcskhcom',
      content: 'https://t.me/QK88BETcskhcom'
    }
  ]
  return (
    <div>
      <HeaderNull title={'Liên hệ hỗ trợ'} link={'/usermobile'} />
      <div className='lienhehotro' style={{ marginTop: '50px' }}>
        <div className='lienhehotro_main'>
          {data.map((item, index) => (
            <div className='lienhehotro_item' key={index}>
              <div className='lienhehotro_item_col'>
                <i
                  className='lienhehotro_item_col_icon'
                  style={{ background: `url(${item.icon}) 50% no-repeat` }}
                ></i>
                <span>{item.name}</span>
              </div>
              <div className='lienhehotro_item_col'>
                <a href={item.link}>{item.content}</a>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className='lienhehotro_bottom'>
        <h3>Thời gian làm việc:24/7</h3>
        <h6>
          Thời gian làm việc trong múi giờ số 8 sẽ cố gắng trả lời trong 1h. Múi
          giờ khác sẽ trả lời trong 24 giờ
        </h6>
      </div>
    </div>
  )
}

export default LienHeHoTro
